import { showDialogWithData } from "../../../redux/guest-slices/other.slice"
import { retrieveAllBlogs } from "../../../redux/admin-slices/blogs.slice"
import { DELETE_BLOG, UPDTAE_BLOG_STATUS } from "../../../utils/keywords"
import TablePagination from "../../../components/common/PaginationSkell"
import SkeletonImage from "../../../components/common/SkeletonImage"
import EntriesSelect from "../../../components/ui/EntriesSelect"
import { debounce, FILE_PATH_URI } from "../../../utils/helper"
import SelectInputA from "../../../components/ui/SelectInputA"
import TableSkell from "../../../components/common/TableSkell"
import InputFieldA from "../../../components/ui/InputFieldA"
import SelectInput from "../../../components/ui/SelectInput"
import { useDispatch, useSelector } from "react-redux"
import { useEffect, useRef, useState } from "react"
import { Link as NavLink } from "react-router-dom"
import Icons from "../../../assets/js/Icons"

import {
  Box, Button, Container, Grid2 as Grid, IconButton, Table, TableBody,
  TableCell, TableContainer, TableHead, TableRow, Typography
} from "@mui/material"

function AllBlogs() {
  const searchRef = useRef("")
  const statusRef = useRef("")
  const entriesRef = useRef("")
  const dispatch = useDispatch()
  const blogStatusRef = useRef("")
  const [data, setData] = useState({})
  const { refresh, loadings } = useSelector(state => state.otherSlice)

  // handle delete category
  const handleDelete = (blogId) => {
    dispatch(showDialogWithData({ type: DELETE_BLOG, data: { blogId } }))
  }
  // handle delete category
  const handleStatus = (blogId) => {
    dispatch(showDialogWithData({
      type: UPDTAE_BLOG_STATUS,
      data: { blogId, status: blogStatusRef?.current?.value?.value }
    }))
  }

  // Handle retrieve all FAQs
  const handleRetrieveAll = (filters) => {
    dispatch(retrieveAllBlogs({
      search: searchRef?.current?.value || null,
      limit: entriesRef?.current?.value || null,
      currentPage: filters?.currentPage || null,
      status: statusRef?.current?.value?.value || null,
    })
    ).unwrap().then((data) => {
      setData(data)
    }).catch(() => { })
  }

  // Handle search FAQs
  const handleSearch = debounce(() => {
    handleRetrieveAll()
  }, 1000)

  useEffect(() => {
    handleRetrieveAll()

    // eslint-disable-next-line
  }, [refresh])

  return (
    <Container maxWidth={false} fixed sx={{ py: 5 }}>
      <Box className="overview-container">
        <Typography variant="pageTitle">Blogs</Typography>
        <Button
          to="/blogs/add"
          variant="outlined"
          LinkComponent={NavLink}
          startIcon={<Icons.PlusSolid />}
        >Add Blog
        </Button>
      </Box>

      <Grid container spacing={1} className="filters-grid" justifyContent="space-between">
        <Grid size={{ xs: 12, lg: "auto" }} sx={{ minWidth: { xl: 350 } }}>
          <InputFieldA
            label="Search"
            ref={searchRef}
            onChangeFun={handleSearch}
            placeholder="Search with names"
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: "auto" }}>
          <EntriesSelect
            inputRef={entriesRef}
            label="Entries per page"
            onChange={() => {
              setTimeout(() => {
                handleRetrieveAll()
              }, 0)
            }}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6, lg: "auto" }}>
          <SelectInput
            inputRef={statusRef}
            label="Approval type"
            renderValueKey="name"
            disabledInitial={false}
            selectLabel="Select a value"
            onChange={() => {
              setTimeout(() => {
                handleRetrieveAll()
              }, 0)
            }}
            options={[
              { name: "Pending", value: "pending" },
              { name: "Approved", value: "approved" },
              { name: "Rejected", value: "rejected" },
            ]}
          />
        </Grid>
      </Grid>

      <Box className="content-listing">
        <TableContainer className="adminTable1">
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                {["Image", "Title", "Status", "Views", "Action"]?.map((cell, i) => (
                  <TableCell key={i} align="left">{cell}</TableCell>
                ))
                }
              </TableRow>
            </TableHead>
            <TableBody>
              {loadings?.retrieveAll ?
                <TableSkell colLength={5} /> :
                data?.records?.map((element, i) => (
                  <TableRow
                    key={i}
                    tabIndex={-1}
                    role="checkbox"
                    sx={{ "td": { borderBottomWidth: i === (data?.records?.length - 1) ? "0" : "1px" } }}
                  >
                    <TableCell sx={{ width: { xs: 80, sm: 100 } }}>
                      <SkeletonImage
                        sx={{
                          width: { xs: "60px", sm: "80px" },
                          height: { xs: "45px", sm: "60px" },
                          maxHeight: "60px",
                          borderRadius: 1,
                          objectFit: "cover",
                        }}
                        src={FILE_PATH_URI + element?.banner?.path}
                      />
                    </TableCell>
                    <TableCell sx={{ textTransform: "capitalize" }}>{element?.title}</TableCell>
                    <TableCell>
                      <SelectInputA
                        renderValueKey="name"
                        value={element?.status}
                        inputRef={blogStatusRef}
                        loading={loadings?.retrieveAll}
                        key={`${element?._id}-${element?.status}`}
                        onChange={() => {
                          setTimeout(() => {
                            handleStatus(element?._id)
                          }, 0)
                        }}
                        options={[
                          { name: "Pending", value: "pending" },
                          { name: "Approved", value: "approved" },
                          { name: "Rejected", value: "rejected" },
                        ]}
                      />
                    </TableCell>
                    <TableCell>{element?.views}</TableCell>
                    <TableCell>
                      <IconButton
                        size="small"
                        sx={{ mr: 0.5 }}
                        LinkComponent={NavLink}
                        to={`/blogs/edit/${element?._id}`}
                      >
                        <Icons.EditSolid />
                      </IconButton>
                      <IconButton
                        size="small"
                        onClick={() => { handleDelete(element?._id) }}
                      >
                        <Icons.DeleteSolid />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))
              }

              {(!data?.records?.length && !loadings?.retrieveAll) &&
                <TableRow sx={{ "td": { borderBottom: "none" } }}>
                  <TableCell colSpan={5}>
                    <Typography variant="noRecords">No results found!</Typography>
                  </TableCell>
                </TableRow>
              }
            </TableBody>
          </Table>
        </TableContainer>

        <TablePagination
          cb={handleRetrieveAll}
          pagination={data?.pagination}
          length={data?.records?.length}
          loading={loadings?.retrieveAll}
        />
      </Box>
    </Container>
  )
}

export default AllBlogs